import { CheckboxGroup, Loading, TextSpan } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EventCategoryOptionResource } from "../../types/eventCategory";
import { EventCategoryMultiSelectField } from "../../ui/EventCategoryMultiSelectField";
import { FilterAccordionBody, FilterAccordionItem, FilterCheckbox } from "./AccordionFilterItemStyles";
import { useEventFilterAccordionItems } from "./EventFilterAccordionItemsProvider";

interface Props {
	name: string;
}

export const AccordionItemCategory: FC<Props> = ({ name }) => {
	const { t } = useTranslation();
	const [{ value }, , { setValue }] = useField<EventCategoryOptionResource[]>(name);
	const { categories, categoriesIsLoading, renderCategoriesAsCheckboxes } = useEventFilterAccordionItems();

	if (!categories || !categories.length) {
		return null;
	}

	const renderBody = () => {
		if (categoriesIsLoading) return <Loading />;
		if (renderCategoriesAsCheckboxes) {
			return (
				<CheckboxGroup name={name}>
					{categories.map((eventCategory) => (
						<FilterCheckbox
							key={`${eventCategory.id}`}
							name={`eventCategory-${eventCategory.id}`}
							value={value.some((v) => v.id === eventCategory.id)}
							label={eventCategory.name}
							onChange={(e) =>
								setValue(e.target.value ? [...value, eventCategory] : value.filter((v) => v.id !== eventCategory.id))
							}
						/>
					))}
				</CheckboxGroup>
			);
		}
		return <EventCategoryMultiSelectField name={name} label="" />;
	};

	return (
		<FilterAccordionItem
			title={t("Category")}
			initialOpen={true}
			actions={<TextSpan $size="small">{t("IN_RELATION")}</TextSpan>}
			body={<FilterAccordionBody>{renderBody()}</FilterAccordionBody>}
		/>
	);
};
